import * as React from "react"
import styled from "styled-components"
import { Link } from "react-router-dom"
import branding from "../../branding/branding"
import { device } from "../../utils/Device"

const EmptyTileWrapper = styled.div<{ backgroundColor: string}>`
    display: flex;
    align-items: center;
    justify-content: center;
    width: calc(100% - 10px);
    height: 95px;
    background-color: ${(props) => props.backgroundColor};
    color: ${branding.primaryColor ?? "black"};
    font-family: ${branding.font1};
    border-radius: 5px;

    @media ${device.tablet} {
        font-size: 16pt;
        width: 100%;
        height: 180px;
    }

    @media ${device.mobile} {
        width: calc(100% - 10px);
        height: 95px;
    }

    a {
        color: ${branding.primaryColor ?? "black"};
        text-decoration: underline;
    }
`

const EmptyTileRow = styled.div<{headerFontWeight?: number, padding?: string}>`
    /* height: 45%; */
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    text-align: center;
    font-family: ${branding.font1};
    color: ${branding.receptionPage.emptyTileTextColor};
    font-style: normal;
    font-weight: ${props  => props.headerFontWeight ? props.headerFontWeight : 700};
    font-size: 16px;
    padding: ${props => props.padding ? props.padding : '0'};
`

type OpenMoreBtn = {
    message: string
    navLink: string
}

const EmptyTileButton: React.FunctionComponent<OpenMoreBtn> = (props) => {
    return <EmptyTileButtonPanel to={props.navLink}>{props.message}</EmptyTileButtonPanel>
}

const EmptyTileButtonPanel = styled(Link)`
    display: block;
    font-family: ${branding.font1};
    font-style: normal;
    font-weight: 300;
    font-size: 24px;
    line-height: 26px;
    border-radius: 40px;
    border: 1px solid;
    border-color: ${branding.primaryColor ?? "#000"};
    background-color: transparent;
    color: ${branding.primaryColor ?? "#000"};
    padding: 0.4rem 2rem;

    &:hover {
        background-color: ${branding.primaryColor ?? "#000"};
        color: #fff;
        text-decoration: none;
    }
`

interface EmptyTileProps {
    header: string
    headerFontWeight?: number
    buttonNavLink?: string
    buttonMessage?: string
    bgColor: string
    hideButton?: boolean
    headerClickable?: boolean
    headerClickableWord?: string
    headerLink?: string
    padding?: string
}

function clickableHeader(label: any, value: any, link: any) {
    if (!value) {
        return label
    }
    return (
        <span>
            {label.split(value).reduce((prev: any, current: any, i: any) => {
                if (!i) {
                    return [current]
                }
                return prev.concat(
                    <Link to={link} key={value + current}>
                        {value}
                    </Link>,
                    current
                )
            }, [])}
        </span>
    )
}

const EmptyTile: React.FunctionComponent<EmptyTileProps> = (props: EmptyTileProps) => {
    return (
        <EmptyTileWrapper backgroundColor={props.bgColor}>
            <EmptyTileRow headerFontWeight={props.headerFontWeight} padding={props.padding}>
                {!props.headerClickable && props.header}

                {props.headerClickable &&
                    props.headerClickableWord &&
                    props.headerLink &&
                    clickableHeader(props.header, props.headerClickableWord, props.headerLink)}

                {props.hideButton ? null : (
                    <EmptyTileButton
                        navLink={props.buttonNavLink ? props.buttonNavLink : ""}
                        message={props.buttonMessage ? props.buttonMessage : ""}
                    />
                )}
            </EmptyTileRow>
        </EmptyTileWrapper>
    )
}

export default EmptyTile
